"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cloneWithProps = void 0;
var preact_1 = require("preact");
var cloneWithProps = function (input, props) {
    if (!input) {
        return;
    }
    else if (typeof input == 'string' || typeof input == 'number' || typeof input == 'boolean') {
        return input;
    }
    else if (Array.isArray(input)) {
        return input.map(function (entry) {
            return (0, exports.cloneWithProps)(entry, props);
        });
    }
    return (0, preact_1.cloneElement)(input, props);
};
exports.cloneWithProps = cloneWithProps;
